export default "__VITE_ASSET__PW5sGkEi__"